import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { QueryInterface } from "app/shared/common/parse/query-interface";
import { ParseService } from "app/shared/common/parse/parse.service";
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-project-create',
  templateUrl: './project-create.component.html',
  styleUrls: ['./project-create.component.scss'],

})

export class ProjectCreateComponent implements OnInit {
  objectId: '';
  isEdit: boolean;
  projectId: any;
  index: number = 0;
  empRole = '';
  selected = new FormControl(0);
  tabIndex = 0;
  projectType: any;
  projectName: string;
  typeOfProject: any;
  routingData: any;
  metricsRoute: Boolean = false;
  tenantId: any;
  onboard: any;
  isOnHold: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private router: Router,
    private storageConfiguration: StorageConfiguration
  ) {

  }

  ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.isEdit = false;
    this.route.params.subscribe(params => {
      let tabIndex = params['index'];
      this.onboard = params.onboard;
      this.isOnHold = params['isOnHold'];

      if (tabIndex) {
        this.tabIndex = tabIndex;
        this.tabChange(Number(tabIndex));
      }
      this.objectId = params['id'];

      this.routingData = params['route'];
      if (this.routingData == 'true') {
        this.metricsRoute = true;
      }

      this.projectId = this.objectId;
      this.typeOfProject = params['projectType'];
      if (this.objectId != '' && this.objectId != undefined) {
        this.isEdit = true;
        this.getLeadersProjectId();
      }
    });
  }

  async getLeadersProjectId() {
    if (this.empRole != 'Admin') {
      await this.queryInterface.executeQuery(this.parseService, 'ProjectMembers',
        [
          { condition: 'include', value: 'client' },
          { condition: 'include', value: 'project' },
          { condition: 'include', value: 'project.client' },
          { condition: 'include', value: 'user' },
          { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
          {
            condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId }
          }]).then(results => {
            var result = results[0];
            var project = result.get('project');
            this.projectId = project.id;
            this.projectName = project.get('projectInfo').projectName;
            if (!this.typeOfProject) {
              this.typeOfProject = 'Project';
            }
          });
    } else {
      this.projectId = this.objectId;
      await this.queryInterface.executeQuery(this.parseService, 'Project',
        [{ condition: 'equalTo', field: 'objectId', value: this.objectId }]).then(results => {
          var result = results[0];
          this.projectName = result.get('projectInfo').projectName;
        });
    }
  }

  tabChange(event) {
    if (event === 0) {
      this.index = 0;
    } else if (event === 1) {
      this.projectId = this.projectId;
      this.index = 1;
    }
    else if (event === 2) {
      this.projectId = this.projectId;
      this.index = 2;
    }
    else if (event === 3) {
      this.projectId = this.projectId;
      this.index = 3;
    }
    else if (event === 4) {
      this.projectId = this.projectId;
      this.index = 4;
    }
    else if (event === 5) {
      this.projectId = this.projectId;
      this.index = 5;
    }
    else if (event === 6) {
      this.projectId = this.projectId;
      this.index = 6;
    }
    else if (event === 7) {
      this.projectId = this.projectId;
      this.index = 7;
    }
    else if (event === 8) {
      this.projectId = this.projectId;
      this.index = 8;
    }
  }

  hideTabs(event) {
    this.isEdit = event;
  }

  getProjectType(event) {
    this.projectType = event;
  }

  backlocation() {
    if (this.metricsRoute == true) {
      this.router.navigate(['project-metrics']);
    }
    if (this.typeOfProject == 'Sub-Project' && this.empRole == 'Admin') {
      this.router.navigate(['admin-addons-list']);
    }
    else if (this.onboard == 'true') {
      this.router.navigate(['onboarding']);
    }
    else if (this.isOnHold) {
      this.router.navigate(['on-hold-project-list']);
    }
    else {
      this.router.navigate(['on-going-project-list']);
    }
  }

  createdProject(event) {
    if (event != '' && event != undefined) {
      this.projectId = event;
    }
  }

}